/* global femcare */

femcare.search.searchBar = {
    pageIndex: 0,

    init: function () {
        if ($('.search-bar .search-bar__field input').length) {
            this.initSearchForm();
            this.initLoadMoreButton();
        }
    },

    /**
     * Init search form to handle fetching more search results.
     * */
    initSearchForm: function () {
        var that = this,
            $form = $('.search-bar form');

        $form.on('submit', function (e) {
            e.preventDefault();
            that.search($(this));
        });

        if (this.getParameterByName('q')) {
            $('.search-bar__field input[name=q]').val(this.getParameterByName('q'));
            that.search($form);
        }
    },

    /**
     * Init load more results after clicking load-more button event.
     */
    initLoadMoreButton: function () {
        var that = this;

        $(document).on('click', '.search-results__load-more', function (e) {
            e.preventDefault();
            that.pageIndex++;

            var $container = $(this)
                .parent()
                .find('.search-results__container');
            var $searchForm = $('.search-bar form');
            var hits = $('.search-bar__field input[name=hits]').val();
            var offset = that.pageIndex * hits;
            var $loadMoreButton = $('.search-results__load-more');
            $loadMoreButton.prop('disabled', true);

            $container.addClass('loading');

            $.ajax({
                type: 'GET',
                data: $searchForm.serialize(),
                url: $searchForm.attr('action') + '?offset=' + offset,
                success: function (data) {
                    $loadMoreButton.remove();
                    var results = $(data)
                        .find('.search-results__list')
                        .children();
                    var loadMoreButton = $(data).find('.search-results__load-more');

                    if (results.length) {
                        $('.search-results__list').append(results);
                        $('.search-results__load-more-container').append(loadMoreButton);
                    }

                    $container.removeClass('loading');
                }
            });
        });
    },

    /**
     * Perform the AJAX search.
     *
     * @param {jQuery} $form - Search form.
     */
    search: function ($form) {
        var $container = $form.parents().find('.search-results__container');
        var $loadMoreButton = $('.search-results__load-more');
        var $noResultsContainer = $('.search-results__no-results');
        var searchTerm = $('.search-bar__field input[name=q]').val();
        $loadMoreButton.remove();
        $noResultsContainer.remove();
        $container.addClass('loading');
        this.pageIndex = 0;

        femcare.tracking.gaTracking.formSubmit($form);

        window.history.replaceState(null, null, '?q=' + searchTerm);

        $.ajax({
            type: $form.attr('method'),
            data: $form.serialize(),
            url: $form.attr('action'),
            success: function (data) {
                var $loadedSearchResults = $(data);
                $('.search-results').replaceWith($loadedSearchResults);
                var articles = $(data)
                    .find('.search-results__list')
                    .children();

                if (articles.length) {
                    $container.show();
                    $('.search-results__no-results').remove();
                } else {
                    $container.hide();
                    $('.search-results__load-more').remove();
                    $('.search-results__container').remove();
                    $('.search-results__no-results').show();
                }

                $('.search-content').hide();
                $('.search-results').show();
                $container.removeClass('loading');
            }
        });
    },

    // Helper function to get parameter from the url/querystring
    getParameterByName: function (name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
};
